import { render } from "./ApplyImplantStatement.vue?vue&type=template&id=568084fd&scoped=true"
import script from "./ApplyImplantStatement.vue?vue&type=script&lang=js"
export * from "./ApplyImplantStatement.vue?vue&type=script&lang=js"

import "./ApplyImplantStatement.vue?vue&type=style&index=0&id=568084fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568084fd"]])

export default __exports__